import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import CategoryIcon from "@mui/icons-material/Category";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PauseIcon from "@mui/icons-material/Pause";

export interface CategoryConfig {
  id: number;
  categoryId: number;
  label: string;
  icon: React.ReactNode;
  description: string;
  example: string;
}

export const CATEGORY_CONFIGS: CategoryConfig[] = [
  {
    categoryId: 4,
    id: 0,
    label: "Change Values",
    icon: <EditIcon color="primary" />,
    description:
      "Use this to correct the value by editing or modifying it within the same field.",
    example:
      'E.g., Model: "Mercedesbenzsprinter" → "Sprinter" (removing Mercedes Benz from model)',
  },
  {
    categoryId: 3,
    id: 1,
    label: "Purge Values",
    icon: <DeleteIcon color="primary" />,
    description:
      "Use this to remove the value from the dataset while keeping the entity intact.",
    example: 'E.g., Remove "Unknown" or "N/A" from the dataset',
  },
  {
    categoryId: 8,
    id: 2,
    label: "Purge Entities",
    icon: <DeleteForeverIcon color="primary" />,
    description:
      "Use this to remove the entire entity (complete row) from the dataset.",
    example: 'E.g., Delete entire row where Make = "Test Data"',
  },
  {
    categoryId: 6,
    id: 3,
    label: "Move Values",
    icon: <SwapHorizIcon color="primary" />,
    description:
      "Use this to send values to the right action process or category for proper handling.",
    example: 'E.g., Move "Dr." from Name field to Title field',
  },
  {
    categoryId: 7,
    id: 4,
    label: "Split Values",
    icon: <CallSplitIcon color="primary" />,
    description:
      "Use this to break one value into multiple correct fields when data is combined incorrectly.",
    example:
      'E.g., Model: "Mercedesbenzsprinter" → Make: "Mercedes Benz", Model: "Sprinter"',
  },
  {
    categoryId: 2,
    id: 5,
    label: "Reclassify Values",
    icon: <CategoryIcon color="primary" />,
    description:
      "Use this when it is the wrong kind of entity and you want to change the entity type or classification.",
    example: "E.g., Change Person entity to Company entity",
  },
  {
    categoryId: 1,
    id: 6,
    label: "Valid Values",
    icon: <CheckCircleIcon color="primary" />,
    description:
      "Use this to mark values as correct and valid, requiring no changes or actions.",
    example: 'E.g., Make: "Mercedes Benz" is already correct',
  },
  {
    categoryId: 9,
    id: 7,
    label: "OnHold Values",
    icon: <PauseIcon color="primary" />,
    description:
      "Use this as a temporary holding queue when you cannot decide what action to take right now.",
    example: 'E.g., Put "Uncertain" values in queue for later review',
  },
];
